'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.Icon', ['$resource', 
		function ($resource) {
			return $resource(
				'/api/icon/:id',
				{},
				{
					'create': { method: 'POST', isArray: false },
					'list': { method: 'GET', isArray: true },
					'get': { method: 'GET', isArray: false },
					'update': { method: 'PATCH' },
					'delete': { method: 'DELETE' }
				}
			);
		}]);